import { useRef, useState } from 'react';
import { uploadImage } from '../../services/adminService';
import AdminImagePickerModal from './AdminImagePickerModal';
import AdminImageCropModal from './AdminImageCropModal';

export default function AdminImageInput({ value, onChange, placeholder, pickableImages, cropAspect = 7 / 4 }) {
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState('');
  const fileRef = useRef(null);
  const [picking, setPicking] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setErr('');
    try {
      const url = await uploadImage(file);
      onChange(url);
    } catch (error) {
      setErr(error.message);
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleCropConfirm = async (blob) => {
    setCropSrc(null);
    setUploading(true);
    setErr('');
    try {
      const file = new File([blob], `crop-${Date.now()}.png`, { type: 'image/png' });
      const url  = await uploadImage(file);
      onChange(url);
    } catch (error) {
      setErr(error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', flex: 1 }}>
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <input
          className="admin-input"
          style={{ flex: 1 }}
          placeholder={placeholder || 'https://... 또는 아래 버튼으로 업로드'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <button
          type="button"
          className="admin-btn-upload"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
        >
          {uploading ? '올리는 중…' : '↑ 업로드'}
        </button>
        {pickableImages?.length > 0 && (
          <button
            type="button"
            className="admin-btn-upload"
            onClick={() => setPicking(true)}
            disabled={uploading}
          >
            ✂ 삽입 이미지에서 선택
          </button>
        )}
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleFile}
        />
      </div>

      {err && <span style={{ fontSize: '0.75rem', color: '#ef4444' }}>{err}</span>}

      {value && !uploading && (
        <div className="admin-img-preview">
          <img src={value} alt="preview" />
        </div>
      )}

      {picking && (
        <AdminImagePickerModal
          images={pickableImages}
          onSelect={(url) => { setPicking(false); setCropSrc(url); }}
          onClose={() => setPicking(false)}
        />
      )}

      {cropSrc && (
        <AdminImageCropModal
          src={cropSrc}
          aspect={cropAspect}
          onConfirm={handleCropConfirm}
          onCancel={() => setCropSrc(null)}
        />
      )}
    </div>
  );
}
